import React, { useState } from 'react';
import DataTable from '../../../Common/DataTable';
import { PlusCircle, Edit, Trash2 } from 'react-feather';
import PowerOfAttorneyDataModal from '../CustomerDetailModals/PowerOfAttorneyDataModal';
import DeleteConfirmationModal from '../../../Common/Modals/DeleteConfirmationModal';
import { toast } from 'react-toastify';
import { H5 } from '../../../../AbstractElements';
import { apiClient } from '../../../../Api/client';

const PowerOfAttorneyInfo = ({ powersOfAttorney = [], onDataChange, customerId, isLoading = false }) => {
    const [selectedRows, setSelectedRows] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [mode, setMode] = useState('add');
    const [selectedPowerOfAttorney, setSelectedPowerOfAttorney] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);
    const [toggleCleared, setToggleCleared] = useState(false);

    const columns = [
        { name: 'Vekalet Numarası', selector: row => row.poaNumber || '', sortable: true },
        { name: 'Vekalet Tarihi', selector: row => row.poaDate && row.poaDate !== '0001-01-01T00:00:00Z' ? new Date(row.poaDate).toLocaleDateString() : '', sortable: true },
        { name: 'Vekalet Bitiş Tarihi', selector: row => row.isPoaTimeLimited ? (row.poaEndDate && row.poaEndDate !== '0001-01-01T00:00:00Z' ? new Date(row.poaEndDate).toLocaleDateString() : '') : 'Süresiz', sortable: true },
        { name: 'Noter', selector: row => row.notaryOfPoa || '', sortable: true },
        { name: 'Plaka Sınırlaması', selector: row => row.isLicensePlatesLimited ? 'Var' : 'Yok', sortable: true },
        { name: 'Plaka Kaza Tarihi', selector: row => row.licensePlateLimitAccidentDate && row.licensePlateLimitAccidentDate !== '0001-01-01T00:00:00Z' ? new Date(row.licensePlateLimitAccidentDate).toLocaleDateString() : '', sortable: true },
        { name: 'Aslı Geldi', selector: row => row.poaOriginalArrived ? 'Evet' : 'Hayır', sortable: true },
        {
            name: 'Düzenle',
            cell: (row) => (
                <div
                    className="btn btn-outline-warning"
                    onClick={() => handleEdit(row)}
                    title="Düzenle"
                >
                    <Edit size={18} />
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            right: true,
        },
    ];

    const clearSelections = () => {
        setSelectedRows([]);
        setToggleCleared(!toggleCleared);
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setMode('add');
        setSelectedPowerOfAttorney(null);
        clearSelections();
        onDataChange();
    };

    const handleEdit = (row) => {
        setSelectedPowerOfAttorney(row);
        setMode('modify');
        setIsModalOpen(true);
    };

    const handleDelete = async (selectedItems) => {
        try {
            setDeleteModal(false);

            for (const item of selectedItems) {
                await apiClient.delete(`/powerofattorney/${item.id}`);
            }

            toast.success('Seçili vekaletnameler başarıyla silindi');
            clearSelections();
            onDataChange();
        } catch (error) {
            console.error('Silme hatası:', error);
            toast.error('Vekaletname silinirken bir hata oluştu');
        }
    };

    const handleRowSelected = state => {
        setSelectedRows(state.selectedRows);
    };

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <H5>Vekaletnameler</H5>
                <div className="d-flex">
                    <div className="btn btn-outline-primary ms-2 d-flex align-items-center" onClick={() => {
                        setMode('add');
                        setSelectedPowerOfAttorney(null);
                        setIsModalOpen(true);
                    }}>
                        <PlusCircle className="me-1" />
                        Vekaletname Ekle
                    </div>
                    {selectedRows.length > 0 && (
                        <div className="btn btn-outline-danger ms-2 d-flex align-items-center" onClick={() => setDeleteModal(true)}>
                            <Trash2 size={18} className="me-1"/>
                            Seçilenleri Sil
                        </div>
                    )}
                </div>
            </div>
            <div style={{ minHeight: '200px' }}>
                <DataTable
                    columns={columns}
                    data={powersOfAttorney}
                    pagination
                    selectableRows
                    onSelectedRowsChange={handleRowSelected}
                    clearSelectedRows={toggleCleared}
                    progressPending={isLoading}
                    progressComponent={<div className="py-4 text-center">Yükleniyor...</div>}
                    noDataComponent={isLoading ? null : (
                        <div className="w-100 text-start">Müşteriye ait vekaletname bulunamadı.</div>
                    )}
                />
            </div>

            {isModalOpen && (
                <PowerOfAttorneyDataModal
                    isOpen={isModalOpen}
                    toggle={handleModalClose}
                    mode={mode}
                    selectedPowerOfAttorney={selectedPowerOfAttorney}
                    refreshData={onDataChange}
                    customerId={customerId}
                />
            )}

            <DeleteConfirmationModal
                isOpen={deleteModal}
                toggle={() => {
                    setDeleteModal(!deleteModal);
                    if (!deleteModal) clearSelections();
                }}
                itemsToDelete={selectedRows}
                displayKey="poaNumber"
                onConfirm={() => handleDelete(selectedRows)}
            />
        </>
    );
};

export default PowerOfAttorneyInfo;
